import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, OnChanges, SimpleChanges, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import { ToastService } from 'ng-uikit-pro-standard';
import { MapInformationService } from 'src/app/services/map-information.service';
import CustomStore from 'devextreme/data/custom_store';

@Component({
  selector: 'app-send-email-dinamic',
  templateUrl: './send-email-dinamic.component.html',
  styleUrls: ['./send-email-dinamic.component.scss']
})
export class SendEmailComponent implements OnInit, OnChanges, AfterViewChecked {

  @ViewChild("messagesContainer", { static: false }) messagesContainer: ElementRef;
  @ViewChild("fileInput", { static: false }) fileInput: ElementRef;

  @Input() emailPopup: boolean = false;
  @Input() projectid: any;
  @Output() closeModal = new EventEmitter();

  @Input() reports: any[] = [];
  selectedReports: any[] = [];

  /** Selected report objects with name and xmlTemplate (or other props) from this.reports */
  get selectedReportsData(): { name: string; xmlTemplate?: string; [key: string]: any }[] {
    if (!this.reports || !this.selectedReports || this.selectedReports.length === 0) return [];
    return this.reports.filter(r => r && this.selectedReports.includes(r.name));
  }
  

  emailList: any;
  popupVisibleTemplates: boolean;
  toolbarButtonOptions: any
  helpMeAI: any
  attachFilesButton: any;

  showAIBar = false;
  fullScreen: { stylingMode: string; hint: string; icon: string; onClick: () => void; };
  errorMessage: string;
  errorPopupVisible: boolean;
  addTypeTag: { icon: string; type: string; onClick: () => void; disabled: boolean; };

  toggleAIAssistantBar() {
    this.showAIBar = !this.showAIBar;
  }
  template = {
    id: 0,
    text: '',
    active: 1,
    subject: '',
    createdate: '',
    updateddate: '',
    updatedbyid: '',
    tag: '',
    metadata: '',
    method: 'InsertUpdateNotificationEmailTemplate'
  };

  arrayTemplate: any;
  emailCategory: any;
  selectionModeValueList = 'multiple';
  selectionModeValue = 'single';

  confirmClearEmailPopup: boolean = false; // Controla la visibilidad del modal de confirmación

  readonly maxAttachmentCount = 2;
  readonly maxAttachmentTotalBytes = 5 * 1024 * 1024; // 5 MB
  attachments: { name: string; base64: string; size?: number }[] = [];

  modelEdit: any = {
    id: 0,
    name: "",
    notificationtext: "",
    active: true,
    cubeactive: true,
    frequencyid: null,
    hour: 0,
    senderaccount: "",
    senderpass: "",
    sendername: "",
    subject: "",
    sendto: "",
    template_code: "",
    copyTo: "",
    moduleCube: "",
    Description: "",
    tagids: [],
  };

  items: any = [

    "undo", "redo", "separator",

    {
      name: "size",
      acceptedValues: ["8pt", "10pt", "12pt", "14pt", "18pt", "24pt", "36pt"]
    },
    {
      name: "font",
      acceptedValues: ["Arial", "Courier New", "Georgia", "Impact", "Lucida Console", "Tahoma", "Times New Roman", "Verdana"]
    },

    "separator", "bold", "italic", "strike", "underline", "separator",
    "alignLeft", "alignCenter", "alignRight", "alignJustify", "increaseIndent",
    "decreaseIndent", "separator",
    "orderedList", "bulletList", "separator",

    {
      name: "header",
      acceptedValues: [false, 1, 2, 3, 4, 5]
    },

    "color", "background", "link", "clear", "codeBlock", "blockquote", "separator", "insertTable", "deleteTable",
    "insertRowAbove", "insertRowBelow", "deleteRow", "insertColumnLeft", "insertColumnRight",
    "deleteColumn", "cellProperties", "tableProperties",
  ];

  constructor(
    private toast: ToastService,
    public translate: TranslateService,
    private MapInformationService: MapInformationService,
    private cdr: ChangeDetectorRef // Inyectar ChangeDetectorRef
  ) {

    this.addTypeTag = {
      icon: "edit",
      type: "button",
      onClick: () => {
        this.goUtilityTag()
      },
      disabled: false
    };

    this.getContactsCustomer()
    this.getQuestion()
    this.getSenders();
  }

  ngAfterViewChecked() {
    this.scrollToBottom();
  }

  private scrollToBottom(): void {
    if (this.messagesContainer) {
      this.messagesContainer.nativeElement.scrollTop = this.messagesContainer.nativeElement.scrollHeight;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['reports'] && this.reports && this.reports.length > 0 && this.selectedReports.length === 0) {
      const first = this.reports[0];
      const value = first != null && (first.name !== undefined) ? first.name : first;
      this.selectedReports = [value];
    }
  }

  ngOnInit() {
    if (this.reports && this.reports.length > 0 && this.selectedReports.length === 0) {
      const first = this.reports[0];
      const value = first != null && (first.name !== undefined) ? first.name : first;
      this.selectedReports = [value];
    }
    this.getTemplatesEmail();

    this.emailCategory = [
      { ID: 1, Name: 'Incoming' },
      { ID: 2, Name: 'Outgoing' },
      { ID: 3, Name: 'Draft' },
      { ID: 4, Name: 'Delete' }
    ];






    this.emailList = [{
      key: '2022/01/04',
      items: [
        'Choose between PPO and HMO Health Plan',
        'Google AdWords Strategy',
        'New Brochures',
        'Update NDA Agreement',
        'Review Product Recall Report by Engineering Team'
      ]
    }];



    this.arrayTemplate = [
      { key: 'Create Templates', items: [{ subject: 'Save as new template' }] },
      { key: 'Custom Template', items: [] }
    ];

    this.toolbarButtonOptions = {
      icon: 'fas fa-layer-group c-blue',
      stylingMode: 'text',
      hint: "Use Templates",
      onClick: () => {
        this.getTemplates()
        this.popupVisibleTemplates = true
      },

    };

    this.helpMeAI = {
      stylingMode: 'text',
      hint: "Help me to write",
      icon: "assets/ai6.png", // o tu ícono
      onClick: () => {
        this.toggleAIAssistantBar()
      },
    }

    this.fullScreen = {
      stylingMode: 'text',
      hint: "Help me to write",
      icon: "fas fa-expand",
      onClick: () => {
        this.popupFullScreenEditor = true; // Open the full-screen popup
        this.textFullScreen = this.template.text; // Set the text to be edited in full screen
      },
    }

    this.attachFilesButton = {
      stylingMode: 'text',
      hint: 'Attach files',
      icon: 'fas fa-paperclip',
      onClick: () => {
        if (this.fileInput && this.fileInput.nativeElement) {
          this.fileInput.nativeElement.click();
        }
      }
    };




  }



  onFilesSelected(event: any) {
    const files: FileList | null = event.target.files;
    if (!files || files.length === 0) {
      return;
    }

    const slotsLeft = this.maxAttachmentCount - this.attachments.length;
    if (slotsLeft <= 0) {
      this.toast.error('Maximum ' + this.maxAttachmentCount + ' files allowed.');
      if (this.fileInput && this.fileInput.nativeElement) {
        this.fileInput.nativeElement.value = '';
      }
      return;
    }

    const currentTotalBytes = this.attachments.reduce((sum, a) => sum + (a.size || 0), 0);
    let newTotalBytes = 0;
    const toAdd: File[] = [];
    for (let i = 0; i < files.length && toAdd.length < slotsLeft; i++) {
      const file = files.item(i);
      if (!file) continue;
      const wouldBeTotal = currentTotalBytes + newTotalBytes + file.size;
      if (wouldBeTotal > this.maxAttachmentTotalBytes) {
        this.toast.error('Total size of attachments cannot exceed 5 MB.');
        if (this.fileInput && this.fileInput.nativeElement) {
          this.fileInput.nativeElement.value = '';
        }
        return;
      }
      toAdd.push(file);
      newTotalBytes += file.size;
    }

    if (files.length > slotsLeft) {
      this.toast.error('Only ' + this.maxAttachmentCount + ' files can be selected.');
    }

    for (const file of toAdd) {
      const reader = new FileReader();
      reader.onload = () => {
        const result = reader.result as string;
        const base64 = result && result.indexOf(',') !== -1 ? result.split(',')[1] : result;
        this.attachments.push({
          name: file.name,
          base64: base64,
          size: file.size
        });
      };
      reader.readAsDataURL(file);
    }

    if (this.fileInput && this.fileInput.nativeElement) {
      this.fileInput.nativeElement.value = '';
    }
  }

  removeAttachment(index: number) {
    if (index >= 0 && index < this.attachments.length) {
      this.attachments.splice(index, 1);
    }
  }

  getTemplatesEmail() {
    this.MapInformationService.getEmailTemplate().subscribe(res => {
      // const dataTemplate = res.map(retorno => ({
      //   id: retorno['ID'],
      //   active: retorno['ACTIVE'],
      //   createdate: retorno['CREATEDATE'],
      //   createbyid: retorno['CREATEBYID'],
      //   metadata: retorno['METADATA'],
      //   subject: retorno['SUBJECT'],
      //   tag: retorno['TAG'],
      //   text: retorno['TEXT'],
      //   updatedbyid: retorno['UPDATEDBYID'],
      //   updateddate: retorno['UPDATEDDATE'],
      //   key: 'Custom Template',
      //   method: 'InsertUpdateNotificationEmailTemplate'
      // }));
      // this.arrayTemplate.find(template => template.key === 'Custom Template').items = dataTemplate;
    });
  }

  cancelButtonEmail() {
    this.emailPopup = false;
    this.clearTemplate();
    this.deleteUpdateTemplate();
    this.emailSelected = "";
    this.closeModal.emit(false);
  }

  asignarValue(event, input) {
    this.template[input] = event.value;
  }

  deleteUpdateTemplate() {
    this.arrayTemplate = this.arrayTemplate.filter(template => template.key !== 'Update Templates');
  }

  saveTemplate(comportamiento) {
    this.MapInformationService.insertUpdateEmailTemplate(this.template).subscribe(() => {
      if (comportamiento === 'update') {
        const customTemplate = this.arrayTemplate.find(template => template.key === 'Custom Template');
        const item = customTemplate.items.find(item => item.id === this.template.id);
        if (item) {
          item.subject = this.template.subject;
          item.text = this.template.text;
        }
      } else if (comportamiento === 'new') {
        this.MapInformationService.getEmailTemplate().subscribe((res: Array<any>) => {
          const newTemplate = res[res.length - 1];
          const tempatePros = {
            id: newTemplate['ID'],
            active: newTemplate['ACTIVE'],
            createdate: newTemplate['CREATEDATE'],
            createbyid: newTemplate['CREATEBYID'],
            metadata: newTemplate['METADATA'],
            subject: newTemplate['SUBJECT'],
            tag: newTemplate['TAG'],
            text: newTemplate['TEXT'],
            updatedbyid: newTemplate['UPDATEDBYID'],
            updateddate: newTemplate['UPDATEDDATE'],
            key: 'Custom Template',
            method: 'InsertUpdateNotificationEmailTemplate'
          };
          this.arrayTemplate.find(template => template.key === 'Custom Template').items.push(tempatePros);
        });
      }
      this.deleteUpdateTemplate();
      this.clearTemplate();
      this.toast.success(this.translate.instant('msgTempUpdSucc'));
    });
  }

  selectTemplate(item) {
    this.popupVisibleTemplates = false;
    this.template = item;
    if (!this.arrayTemplate.some(template => template.key === 'Update Templates')) {
      this.arrayTemplate.splice(1, 0, { key: 'Update Templates', items: [{ subject: 'Update template' }] });
    }
  }



  trimText(text: string, maxLength: number): string {
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + '...';
    } else {
      return text;
    }
  }




  getTemplates() {

    this.MapInformationService.SaveInfoSites({ method: "GetActiveEmailTemplate" }).subscribe(res => {
      this.arrayTemplate = res.map((item: any) => {
        item.DESCRIPTIONsinhtml = item.DESCRIPTION.replace(/<[^>]+>/g, ''); // Eliminar etiquetas HTML
        return item
      });
      this.cdr.detectChanges(); // Forzar la actualización de la vista
    });

  }

  CerrarPopupTemplate() {
    this.popupVisibleTemplates = false;
  }

  selectedTemplateKeys: any[] = []

  sendTo: any[] = []
  sendToCC: any[] = []
  sendBcc: any[] = []


  importTemplate() {
    if (!this.selectedTemplateKeys || this.selectedTemplateKeys.length === 0) {
      this.toast.warning("You must select a template before importing");
      return;
    }

    this.template.text = this.selectedTemplateKeys[0].TEXT;
    this.template.subject = this.selectedTemplateKeys[0].NAME;

    this.CerrarPopupTemplate();

  }


  contactDataSource: any

  getContactsCustomer() {
    let mythis = this;

    // this.projectid
    this.contactDataSource = new CustomStore({
      key: "ID",
      useDefaultSearch: false,
      load: function (loadOptions: any) {
        if (loadOptions.searchValue == "" || loadOptions.searchValue == undefined) {
          loadOptions.searchValue = " "
        } else {
          loadOptions.searchValue = loadOptions.searchValue
        }
        return mythis.MapInformationService.GetAllInfoDinamicoContact("Get_ContactsByNameWithDefaultSalesLeadContact", loadOptions.searchValue, mythis.projectid)
          .toPromise()
          .then((data: any) => {
            //console.log(data);
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
      }
    });
  }

  clearTemplate() {
    this.sendTo = [];
    this.sendToCC = [];
    this.sendBcc = [];
    this.attachments = [];
    if (this.reports && this.reports.length > 0) {
      const first = this.reports[0];
      this.selectedReports = first != null && first.name !== undefined ? [first.name] : [];
    } else {
      this.selectedReports = [];
    }
    this.template = {
      id: 0,
      text: '',
      active: 1,
      subject: '',
      createdate: '',
      updateddate: '',
      updatedbyid: '',
      tag: '',
      metadata: '',
      method: 'InsertUpdateNotificationEmailTemplate'
    };
  }

  private closeAndCleanAfterSend(): void {
    this.toast.success("Email sent successfully");
    this.toast.success("Activity saved successfully");
    this.clearTemplate();
    this.emailPopup = false;
    this.closeModal.emit(false);
  }

  sendEmail() {
    const emailAddressessendTo = this.sendTo.length > 0
      ? this.sendTo.map(item => item["Email Address"]).join(',')
      : '';
    const emailAddressessendToCC = this.sendToCC.length > 0
      ? this.sendToCC.map(item => item["Email Address"]).join(',')
      : '';
    const emailAddressessendBcc = this.sendBcc.length > 0
      ? this.sendBcc.map(item => item["Email Address"]).join(',')
      : '';

    const dataFinal = {
      subject: this.template.subject,
      mailto: emailAddressessendTo,
      copyemailto: emailAddressessendToCC,
      copyccemailto: emailAddressessendBcc,
      bodyhtm: this.template.text,
      senderaccountid: this.emailSelected,
      reports: this.selectedReportsData
        .map(r => ({ reportname: r.designName || r.name, reportxml: r.xmlTemplate }))
        .filter(r => r.reportname != null && r.reportxml != null),

      attachmentsBase64: this.attachments.length > 0
        ? this.attachments.map(a => ({ fileName: a.name, contentType: "image/png", base64: a.base64 }))
        : [],

      //   reportname: this.selectedReportsData.map(r => r.designName || r.name).filter(Boolean).join(','),
      // reportxml: this.selectedReportsData.map(r => r.xmlTemplate).filter(Boolean).join(','),
    };

    console.log(dataFinal)

    const employeeid = localStorage.getItem("clienuser");

    this.MapInformationService.EmailDinamicWithReports(dataFinal).subscribe(
      (res: any) => {
        if (res != undefined && res.ok === true) {
          if (this.projectid == null || this.projectid === undefined || this.projectid === 0 || this.projectid === "") {
            this.closeAndCleanAfterSend();
            return;
          }
          const dataActivity = {
            id: 0,
            customerid: 0,
            servicesiteid: null,
            employeeid,
            type: 8,
            notes: "",
            starttime: new Date().toISOString(),
            endtime: "2025-06-11 14:49",
            followup: 0,
            followupdate: new Date().toISOString(),
            name: this.template.subject,
            closed: 0,
            followupcomments: this.template.text,
            projectid: this.projectid,
            duration: "0.0",
            externallink: "",
            sort: 0,
            method: "InsertUpdateActivity"
          };
          this.MapInformationService.SaveInfoSites(dataActivity).subscribe(
            () => this.closeAndCleanAfterSend(),
            () => {
              this.toast.error("Activity could not be saved.");
              this.closeAndCleanAfterSend();
            }
          );
        }
      },
      (error: any) => {
        this.errorMessage = error && error.details ? error.details : "Error sending email.";
        this.errorPopupVisible = true;
      }
    );
  }

  showConfirmClearEmail() {
    this.confirmClearEmailPopup = true; // Muestra el modal de confirmación
  }

  confirmClearEmail() {
    this.clearTemplate(); // Llama a la función existente para limpiar el email
    this.confirmClearEmailPopup = false; // Cierra el modal de confirmación
    this.emailSelected = "";
  }

  cancelClearEmail() {
    this.confirmClearEmailPopup = false; // Cierra el modal de confirmación sin hacer nada
  }

  promptToUser: any
  SYSTEMPROMPT: any

  getQuestion(input = null) {

    const dataSPAI = {
      method: "GetCubeOpenAIQuestionByType",
      topic: "GET_FORMAT_EMAIL_DINAMIC"
    }


    this.MapInformationService.SaveInfoSites(dataSPAI).subscribe(result => {
      console.log(result);

      result.forEach(item => {
        if (item.TYPEPROMPT === "write_email_sales") {
          console.log(item);
          this.SYSTEMPROMPT = item.SYSTEMPROMPT

          this.promptToUser = item.USERPROMPT
        }
      });
    });
  }


  GenerateByAIFullScreen() {

    let prompt = {
      systemPrompt: this.SYSTEMPROMPT,
      userprompt: this.promptToUser,
    }

    this.MapInformationService.GetCodeFromAI(prompt).subscribe(result => {
      this.template.text = result.content
    });
  }


  editItem: boolean = false

  popupNewNotification: boolean = false

  newTemplate(data) {

    console.log(data)

    this.modelEdit = {
      id: 0,
      name: this.template.subject,
      notificationtext: this.template.text,
      active: true,
      cubeactive: "",
      frequencyid: null,
      hour: null,
      senderaccount: "",
      senderpass: "",
      sendername: "",
      subject: "",
      sendto: "",
      template_code: "",
      copyTo: "",
      moduleCube: "",
      Description: "",
      tagids: [],
    };

    this.popupNewNotification = true
    this.editItem = false
    this.getSelect()
  }

  modulesCube: any[] = []
  contactTag: any[] = []
  getSelect() {

    this.MapInformationService.SaveInfoSites({ method: "Get_ModulesNameCE" })
      .subscribe(result => {
        console.log(result)
        this.modulesCube = result.map((val) => {
          return {
            label: val.MODULENAME,
            value: val.ID
          };
        })
      })

    this.MapInformationService.SaveInfoSites({ method: "Get_ClientTags" })
      .subscribe(result => {
        this.contactTag = result.map((val) => {
          return {
            label: val.TAG,
            value: val.ID
          };
        })
      })
  }

  promptGenerate: any
  Html2: any

  GenerateByAIFull(input = null) {



    const dataSPAI = {
      method: "GetCubeOpenAIQuestionByType",
      topic: "COMPANY_EMAIL_DINAMIC"
    }


    this.MapInformationService.SaveInfoSites(dataSPAI).subscribe(result => {
      console.log(result);

      result.forEach(item => {
        if (item.TYPEPROMPT === "get_email_descriptions") {
          console.log(item);

          let prompt = {
            systemPrompt: item.SYSTEMPROMPT,
            userprompt: item.USERPROMPT + ' ' + this.modelEdit.name,
          }

          this.MapInformationService.GetCodeFromAI(prompt).subscribe(result => {
            if (input == "email_description") {
              this.modelEdit.Description = result.content
              this.Html2 = result.content
            }
          });
        } else if (item.TYPEPROMPT === "write_email") {
          console.log(item);

          let prompt = {
            systemPrompt: item.SYSTEMPROMPT,
            userprompt: item.USERPROMPT + ' ' + this.modelEdit.name,
          }

          this.MapInformationService.GetCodeFromAI(prompt).subscribe(result => {
            if (input == "email_Text") {
              this.modelEdit.notificationtext = result.content
              this.Html2 = result.content
            }
          });
        }
      });
    });
  }

  promptToUser2: any
  typeFullScreen: any
  popupFullScreenEditor: boolean = false
  openFullScreenNote: boolean = false

  openFullScreenEditor(type) {

    const dataSPAI = {
      method: "GetCubeOpenAIQuestionByType",
      topic: "COMPANY_EMAIL_DINAMIC"
    }

    this.typeFullScreen = type

    this.MapInformationService.SaveInfoSites(dataSPAI).subscribe(result => {
      console.log(result);

      result.forEach(item => {
        if (type === "email_description") {
          this.promptToUser2 = item.USERPROMPT + ' ' + this.modelEdit.name
          this.Html2 = this.modelEdit.Description
        } else if (type === "email_Text") {
          this.promptToUser2 = item.USERPROMPT + ' ' + this.modelEdit.name
          this.Html2 = this.modelEdit.notificationtext
        }
      });

      this.popupFullScreenEditor = true;
    });
  }

  saveNewFullScreen() {
    if (this.typeFullScreen) {
      this.modelEdit.Description = this.Html2
      this.openFullScreenNote = false
      this.saveNew()
    }
  }

  GenerateByAIFullScreen2(input = null) {



    const dataSPAI = {
      method: "GetCubeOpenAIQuestionByType",
      topic: "COMPANY_EMAIL_DINAMIC"
    }


    this.MapInformationService.SaveInfoSites(dataSPAI).subscribe(result => {
      console.log(result);

      result.forEach(item => {
        if (item.TYPEPROMPT === "get_email_descriptions") {
          console.log(item);

          let prompt = {
            systemPrompt: item.SYSTEMPROMPT,
            userprompt: this.promptToUser2,
          }

          this.MapInformationService.GetCodeFromAI(prompt).subscribe(result => {
            if (input == "email_description") {
              this.modelEdit.Description = result.content
              this.Html2 = result.content
            }
          });
        } else if (item.TYPEPROMPT === "write_email") {
          console.log(item);

          let prompt = {
            systemPrompt: item.SYSTEMPROMPT,
            userprompt: this.promptToUser2,
          }

          this.MapInformationService.GetCodeFromAI(prompt).subscribe(result => {
            if (input == "email_Text") {
              this.modelEdit.notificationtext = result.content
              this.Html2 = result.content
            }
          });
        }
      });
    });
  }

  saveNew() {
    if (!this.modelEdit.name
      || !this.modelEdit.notificationtext) {

      // || !this.modelEdit.moduleCube

      this.toast.warning("All fields are required.");
      return;
    }
    console.log(this.modelEdit);

    let emails = "";




    const sqlParams = {
      id: this.modelEdit.id,
      name: this.modelEdit.name,
      text: this.modelEdit.notificationtext,
      active: this.modelEdit.active == true ? 1 : 0,
      cubeactive: this.modelEdit.cubeactive == true ? 1 : 0,
      sendviaid: null, // Assuming this is not provided in modelEdit
      frequencyid: this.modelEdit.frequencyid,
      hour: null,
      emailtemplatefile: "", // Assuming this is not provided in modelEdit
      iscubebox: false, // Assuming this is not provided in modelEdit
      siteid: null, // Assuming this is not provided in modelEdit
      senderaccount: this.modelEdit.senderaccount,
      senderpass: this.modelEdit.senderpass,
      sendername: this.modelEdit.sendername,
      subject: this.modelEdit.subject,
      sendto: emails,
      method: "InsertUpdateNotificationEmailTemplate",
      code: this.modelEdit.template_code,
      mailcopyto: this.modelEdit.copyTo,
      cubemodule: this.modelEdit.moduleCube,
      description: this.modelEdit.Description,
      tagids: this.modelEdit.tagids.length > 0 ? this.modelEdit.tagids.join(',') : "", // Convert array to comma-separated string
    };

    console.log(sqlParams);

    this.MapInformationService.SaveInfoSites(sqlParams)
      .subscribe(resp => {
        this.toast.success("Notification saved successfully");
        this.getTemplates();
        if (!this.editItem) {
          this.clearModel();
        }
      });
  }

  clearModel() {
    this.modelEdit = {
      id: 0,
      name: "",
      notificationtext: "",
      active: true,
      cubeactive: false,
      frequencyid: null,
      hour: 0,
      senderaccount: "",
      senderpass: "",
      sendername: "",
      subject: "",
      sendto: "",
      template_code: "",
      copyTo: "",
      moduleCube: "",
      Description: "",
      tagids: [],
    };
    this.popupNewNotification = false
  }


  textFullScreen: string = '';
  saveFullScreen() {
    this.template.text = this.textFullScreen;
    this.textFullScreen = '';
    this.popupFullScreenEditor = false;
  }

  closeFullScreen() {
    this.popupFullScreenEditor = false;
    this.textFullScreen = '';
  }

  onEdit(data) {
    console.log(data)
    this.popupNewNotification = true;
    this.editItem = true;
    this.modelEdit = {
      id: data.ID || 0,
      name: data.NAME || "",
      notificationtext: data.TEXT || "",
      active: data.ACTIVE || false,
      cubeactive: false, // Si no está en `data`, se asigna un valor predeterminado
      frequencyid: data.FREQUENCYID || null,
      hour: data.HOUR || null,
      subject: data.SUBJECT || "",
      sendto: data.MAILTO || "",
      template_code: data.CODE || "",
      copyTo: data.MAILCOPYTO || "",
      moduleCube: data.CUBEMODULE || "",
      Description: data.DESCRIPTION || "",
      tagids: data.TAGIDS ? data.TAGIDS.split(',').map(id => parseInt(id)) : [], // Convertir a array de números
    };
    this.getSelect();
  }


  selectedTemplate: any;
  confirmDeletePopup: boolean = false;

  showDeleteConfirmation(data) {
    this.selectedTemplate = data;
    this.confirmDeletePopup = true;
  }

  deleteTemplate() {
    this.MapInformationService.SaveInfoSites({ method: "DeleteEmailTemplate", id: this.selectedTemplate.ID })
      .subscribe(resp => {
        this.toast.success("Template deleted successfully");
        this.getTemplates();
        this.confirmDeletePopup = false;
      }, error => {
        this.toast.error("Error deleting template");
      });
  }

  SaveAsDraft() {
    console.log("Saving as draft...");
  }


  dataSenders: any[] = [];
  emailSelected: any = "";
  getSenders() {
    const employeeid = localStorage.getItem("clienuser")
    this.MapInformationService.SaveInfoSites({ method: "Get_EMPLOYEE_EMAIL_CONNECTIONS", employeeid: employeeid }).subscribe((res: any) => {
      this.dataSenders = res.map(service => {
        const dataParts = service.DATA.split('[+]');
        console.log(dataParts);
        console.log(service);
        if (service.IS_DEFAULT) {
          this.emailSelected = service.ID;
        }

        return {
          id: service.ID,
          employeeId: service.EMPLOYEEID,
          connType: service.CONN_TYPE,
          username: dataParts[0] || '',
          // username: "(" + dataParts[2] + ") " + dataParts[0] || '',
          password: dataParts[1] || '',
          emailServer: dataParts[2] || ''
        };
      });
    })
  }

  showDataAccounts: boolean = false;
  showAccounts() {
    console.log("Showing accounts...");
    this.showDataAccounts = true;
  }

  DuplicateTemplate(data) {
    console.log(data);


    const sqlParams = {
      id: 0,
      name: data.NAME || "",
      text: data.TEXT || "",
      active: 1,
      cubeactive: data.CUBEACTIVE ? 1 : 0,
      sendviaid: data.SENDVIAID || null,
      frequencyid: data.FREQUENCYID || null,
      hour: data.HOUR || null,
      emailtemplatefile: data.EMAILTEMPLATEFILE || "",
      iscubebox: false,
      siteid: null,
      senderaccount: data.SENDERACCOUNT || "",
      senderpass: data.SENDERPASS || "",
      sendername: data.SENDERNAME || "",
      subject: data.SUBJECT || "",
      sendto: data.MAILTO || "",
      method: "InsertUpdateNotificationEmailTemplate",
      code: data.CODE || "",
      mailcopyto: data.MAILCOPYTO || "",
      cubemodule: data.CUBEMODULE || "",
      description: data.DESCRIPTION || "",
      tagids: data.TAGIDS,
    };

    console.log(sqlParams)

    this.MapInformationService.SaveInfoSites(sqlParams)
      .subscribe(
        resp => {
          this.toast.success("Template duplicated successfully");
          this.getTemplates();
        },
        error => {
          this.toast.error("Error duplicating template");
        }
      );
  }

  openUtilityReu: boolean;
  idField: string;
  nameField: string;
  serviceGet: string;
  serviceToSave: string;
  idFieldSaveOrModify: string;
  nameFieldSaveOrModify: string;

  goUtilityTag() {
    console.log("Utility")
    this.openUtilityReu = true

    this.idField = "ID"
    this.nameField = "TAG"
    this.serviceGet = "Get_ClientTags"
    this.serviceToSave = "Save_ClientTag"
    this.idFieldSaveOrModify = "id"
    this.nameFieldSaveOrModify = "tag"
  }


}
